<template>
    <div class="vm-ticket-tip" :class="[browser_size]">
        <div class="fs16 fwb lh1">入场须知</div>
        <div class="fs14 black-8 mt8">
          活动当天，凭二维码电子票与身份证入场，身份证必须与电子票上一致<br/>
          为方便查看电子票，我们建议：
        </div>
        <div class="mt8 purple fs14">关注爱发电公众号 >></div>
        <div class="mt8 purple fs14">下载爱发电App >></div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: 'ticket-tip',
    props: {
        user_id: {
            type: String,
            default() {
                return "";
            },
        },
    },
    data() {
        return {
            is_show_list: false,
            myList:[],
            otherList:[],
            faq_id:this.$route.query.faq_id
        };
    },
    computed:{
        ...mapState("app", ["browser_size","session_user"]),
    },
    async mounted() {
        
    },
    methods: {
        
    }
};
</script>

<style lang="stylus" scoped>
.vm-ticket-tip{
    &.small{
       
    }
}
</style>
